var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88 48V68C88 80 80 88 68 88H28C16 88 8 80 8 68V48C8 37.12 14.56 29.52 24.76 28.24C25.8 28.08 26.88 28 28 28H68C69.04 28 70.04 28.04 71 28.2C81.32 29.4 88 37.04 88 48Z",
    fill: "#F2654E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9998 28.2C70.0398 28.04 69.0398 28 67.9998 28H27.9998C26.8798 28 25.7998 28.08 24.7598 28.24C25.3198 27.12 26.1198 26.08 27.0798 25.12L40.0798 12.08C45.5598 6.64 54.4398 6.64 59.9198 12.08L66.9198 19.1601C69.4798 21.6801 70.8398 24.88 70.9998 28.2Z",
    fill: "#F2654E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 50H76C71.6 50 68 53.6 68 58C68 62.4 71.6 66 76 66H88",
    fill: "#F2654E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.46cac9c9380127177126c3e34f697e44.svg";
export { ForwardRef as ReactComponent };